import { render, staticRenderFns } from "./NiubizForm.vue?vue&type=template&id=6bc6c396&scoped=true"
import script from "./NiubizForm.vue?vue&type=script&lang=js"
export * from "./NiubizForm.vue?vue&type=script&lang=js"
import style0 from "./NiubizForm.vue?vue&type=style&index=0&id=6bc6c396&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6c396",
  null
  
)

export default component.exports